import React from 'react';
import { highlightText } from '../../util';
import styles from './selector.module.scss';
import { TeamAvatar } from '@web-im/common/imUserAvatar';
import IconCard from '@web-common/components/UI/IconCard';
import { getIn18Text } from 'api';
import { CustomerLabelByRole } from '@web-mail/components/ReadMail/component/CustomerLabel';
const OptionItem = props => {
    const { item, search } = props;
    const htmlName = highlightText(item.orgName, search, styles.hitText);
    const isCustomer = item.type === 2002;
    const isTeam = item.type === 2000;
    const isPersonalGroup = item.type === 2001;
    let titleLabelRole;
    if ([2002, 2003].includes(item.type)) {
        titleLabelRole = item.customerRole;
    }
    const teamId = isTeam ? item.id.substr(item.id.indexOf('_') + 1, item.id.length) : '';
    return (React.createElement("div", { className: styles.optionItem, key: item.id },
        React.createElement("div", { className: styles.optionAvatarWrap }, isTeam ? (React.createElement(TeamAvatar, { style: { width: '20px', height: '20px' }, teamId: teamId })) : isPersonalGroup ? (React.createElement(TeamAvatar, { style: { width: '20px', height: '20px' }, teamId: '5117576620' })) : (React.createElement(IconCard, { type: isCustomer ? 'crmClient' : 'hintClient' }))),
        React.createElement("span", { className: styles.optionContactName }, item.orgName + (item.memberNum !== undefined ? `（${item.memberNum}${getIn18Text('REN')}）` : '')),
        titleLabelRole && React.createElement(CustomerLabelByRole, { role: titleLabelRole, style: { marginLeft: 8 } })));
};
export default OptionItem;
